import React, { useEffect } from 'react';
import { Link } from "react-router-dom";

const AboutUs = () => {
    const THEME_COLOR = '#065f46';

    // Scroll to top on page load
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh', paddingTop: '120px' }}>
            {/* Note: Header is usually added in App.js so it shows everywhere automatically */}

            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        {/* Big Card for Content */}
                        <div className="card border-0 shadow-sm p-md-5" style={{ borderRadius: '2rem' }}>
                            
                            <div className="text-center mb-5">
                                <h1 className="display-4 fw-bold" style={{ color: '#064e3b' }}>About Us</h1>
                                <div className="mx-auto mt-3" style={{ width: '60px', height: '4px', backgroundColor: THEME_COLOR, borderRadius: '2px' }}></div>
                            </div>

                            <div className="content-section">
                                <p className="mb-5">
                                    At <strong>MunnyFinds</strong>, we’re redefining how people discover and book beauty services. <strong>MunnyFinds.com</strong> is a streamlined platform that connects customers to beauty and wellness providers and professionals, making it easy to find quality services, secure appointments, and enjoy a seamless experience from search to booking.
                                </p>

                                <h3 className="fw-bold mt-5 mb-3" style={{ color: '#064e3b' }}>Who We Are</h3>
                                <p className="mb-5">
                                    At <strong>MunnyFinds.com</strong>, we’re a team driven by a simple belief: self-care should be easy to access, effortless to book, and delivered with confidence. We understand the value of looking and feeling your best, and we’re building a platform that connects customers with trusted beauty and wellness providers without the hassle. Our mission is to make discovery and booking seamless, reliable, and enjoyable for both customers and professionals.
                                </p>

                                <h3 className="fw-bold mt-5 mb-4" style={{ color: '#064e3b' }}>What We Offer</h3>
                                
                                <div className="row g-4">
                                    {[
                                        { title: "Easy Salon Discovery", desc: "Say goodbye to endless online searches and phone calls. Effortlessly browse through a vast network of salons and beauty professionals in your area." },
                                        { title: "Simple Online Booking", desc: "Book your preferred beauty services with just a few clicks. Choose the date, time, and specific service you desire from any device." },
                                        { title: "Real-Time Availability", desc: "No more guesswork. See open time slots and secure your appointment instantly for a seamless booking experience." },
                                        { title: "User-Friendly Interface", desc: "Our platform is designed to be accessible to all users, regardless of tech-savviness. Easy to navigate for everyone." },
                                        { title: "Customer Reviews", desc: "Read honest customer reviews and ratings for each salon to help you find the perfect match for your needs." },
                                        { title: "Secure Payments", desc: "Your safety is paramount. Our secure payment system ensures that all transactions are protected." }
                                    ].map((item, index) => (
                                        <div className="col-md-6" key={index}>
                                            <div className="p-3 rounded-4 h-100" style={{ backgroundColor: '#f0fdf4', borderLeft: `4px solid ${THEME_COLOR}` }}>
                                                <h6 className="fw-bold mb-2" style={{ color: THEME_COLOR }}>{item.title}</h6>
                                                <p className="small mb-0 text-muted">{item.desc}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <p className="mt-5 text-center ">
                                    Join us today and discover a new era of salon booking simplicity at MunnyFinds.com. Book your next beauty appointment with ease and let us take care of the rest!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ================= FOOTER ================= */}
            <footer className="bg-white pt-5 pb-4 mt-5 border-top border-light position-relative">
                <div className="container">
                    <div className="row align-items-center mb-4">
                        <div className="col-md-6 mb-3 mb-md-0">
                            <span className="text-dark fs-5 fw-medium">Payment methods:</span>
                            <div className="d-flex gap-3 mt-3 align-items-center">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" style={{ height: '22px' }} />
                                <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" style={{ height: '22px' }} />
                                <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="MasterCard" style={{ height: '25px' }} />
                                <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/American_Express_logo_%282018%29.svg" alt="Amex" style={{ height: '22px' }} />
                            </div>
                        </div>
                        <div className="col-md-6 text-md-end">
                            <span className="text-dark fs-5 fw-medium">Keep in touch</span>
                            <div className="d-flex gap-3 justify-content-md-end mt-3 fs-3 text-secondary">
                                <i className="ri-facebook-box-fill"></i>
                                <i className="ri-twitter-x-line"></i>
                                <i className="ri-instagram-line"></i>
                                <i className="ri-threads-line"></i>
                            </div>
                        </div>
                    </div>

                    <hr className="my-5" style={{ borderTop: '1px dotted #dee2e6' }} />

                    <div className="text-center">
                        <div className="d-flex flex-wrap justify-content-center gap-4 mb-4">
                            <a href="/Frequently-Asked-Questions.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-medium text-dark">FAQ</a>
                            <a href="/Partner-Terms.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-medium text-dark">Partner Terms</a>
                            <a href="/Terms-and-Condition.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-medium text-dark">Terms & Conditions</a>
                            <a href="/Partner-Terms.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-medium text-dark">Terms of use</a>
                            <a href="/Privacy-Policy.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-medium text-dark">Privacy Policy</a>
                        </div>
                        <p className="small text-muted mb-0">Copyright © 2026 <span className="fw-bold text-dark">Munny Finds</span>. All Rights Reserved</p>
                    </div>

                    <button 
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
                        className="btn position-absolute bottom-0 end-0 m-4 rounded-circle d-flex align-items-center justify-content-center shadow-sm" 
                        style={{ backgroundColor: '#86efac', width: '50px', height: '50px', border: 'none', color: 'white' }}
                    >
                        <i className="ri-arrow-up-line fs-4"></i>
                    </button>
                </div>
            </footer>
        </div>
    );
};

export default AboutUs;